import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as selectors from '../../reducers';
import styles from '../entity-region-page.module.scss';
import RegionMapContainer from '../../components/region-map-container';
import {
  setActiveRegion,
  setComparedRegion,
  setActivePage,
  setComparedEntity,
  setActiveEntity,
} from '../../actions/ui';
import { dataCategories } from '../../helpers/formatters';
import { EntityLabels } from '../../helpers/label-mapper';
import scrollToComponent from '../../helpers/scroll-to-component';
import DataCard from '../../components/data-card';
import { RegionGrid } from '../../components/region-entity-table/region-info-grid';
import EntitiesLinks from '../../components/region-entity-table/entities-links';

class RegionPage extends Component {
  constructor() {
    super();
    this.cardElements = {};
    this.selectRegion = this.selectRegion.bind(this);
    this.selectComparedRegion = this.selectComparedRegion.bind(this);
    this.goToSearch = this.goToSearch.bind(this);
    this.goToCompare = this.goToCompare.bind(this);
    this.scrollTo = this.scrollTo.bind(this);
  }

  scrollTo(card) {
    const element = this.cardElements[card];
    scrollToComponent(element);
  }

  goToSearch() {
    const { setActivePage, setActiveRegion, setComparedRegion } = this.props;
    setActivePage('search');
    setActiveRegion(null);
    setComparedRegion(null);
  }

  goToCompare() {
    const { setActivePage } = this.props;
    setActivePage('compareSelect');
  }

  selectRegion(regionId) {
    const { setActiveRegion } = this.props;
    setActiveRegion(regionId);
  }

  selectComparedRegion(regionId) {
    const { setComparedRegion } = this.props;
    setComparedRegion(regionId);
  }

  comparisonWithNoDataRegions() {
    const { activeCouncil, comparedCouncil } = this.props;
    return (
      activeCouncil &&
      activeCouncil.isBlank &&
      comparedCouncil &&
      comparedCouncil.isBlank
    );
  }

  renderDataCards() {
    if (this.comparisonWithNoDataRegions()) return null;
    return dataCategories.map((card) => {
      return (
        <DataCard
          key={card.id}
          ref={(el) => (this.cardElements[card.id] = el)}
          id={card.id}
          color={card.color}
          label={card.label}
        />
      );
    });
  }

  renderMaps() {
    const { activeCouncil, comparedCouncil, comparing } = this.props;

    return (
      <div
        className={`${styles.mapsRow} ${styles.comparedMapsRow}`}
        data-comparing={comparing}
      >
        <RegionMapContainer
          key={comparing ? 0 : 1}
          onCouncilSelect={this.selectRegion}
          council={activeCouncil}
          comparing={comparing}
          comparisonId={comparing ? comparedCouncil.id : null}
        />
        {comparing ? (
          <RegionMapContainer
            key={2}
            council={comparedCouncil}
            onCouncilSelect={this.selectComparedRegion}
            comparing={comparing}
            isComparisonCouncil={true}
          />
        ) : null}
      </div>
    );
  }

  renderNoDataNotice() {
    const { activeCouncil } = this.props;
    return activeCouncil.isBlank ? (
      <div className={styles.noDataNotice}>
        <span className={styles.noDataNoticeHeading}>notice</span>
        <span>
          {activeCouncil.name === 'Bayside Council'
            ? "No audited financial statement data available. See Auditor-General's Local Government 2017 report for details."
            : "No data presented. A modified audit opinion was issued on the financial statements. See Auditor-General's Local Government 2017 report for details."}
        </span>
      </div>
    ) : null;
  }

  renderRegionTable() {
    // const { activeCouncil, comparing, comparedCouncil } = this.props;
    const { activeCouncil } = this.props;

    return (
      <div>
        <div className={styles.regionTableArea}>
          <RegionGrid
            region={activeCouncil}
            title="Managed by QLD Government"
            hasHeaderCol={true}
            fields={[
              EntityLabels.qtripsNationalNetworkIndicativeTotalProjectsCost,
              EntityLabels.qtripsStateNetworkIndicativeTotalCost,
              EntityLabels.qtripsLocalNetworkIndicativeTotalCost,
              EntityLabels.lengthOfManagedRoads,
              EntityLabels.numberOfBridges,
            ]}
          />
        </div>
        <div className={`${styles.regionTableArea} ${styles.secondArea}`}>
          <RegionGrid
            region={activeCouncil}
            title="Managed by Council"
            hasHeaderCol={false}
            fields={[
              EntityLabels.kilometresOfCouncilManagedRoad,
              EntityLabels.numberOfBridgesCouncilManaged,
              EntityLabels.totalCapitalExpenditureOnRoads,
              EntityLabels.totalMaintenanceExpenditureOnRoads,
              EntityLabels.writtenDownValueOfRoadsBridgesAndMajorCulvert,
              EntityLabels.valuationLastPeformed,
            ]}
          />
        </div>
      </div>
    );
  }

  renderEntitiesLinks() {
    return <EntitiesLinks />;
  }

  render() {
    const { activeCouncil } = this.props;
    return (
      <div className={styles.councilPage}>
        <div className={styles.buttonsRow}>
          <button
            type="button"
            className={styles.backLink}
            onClick={this.goToSearch}
          >
            <img
              className={styles.backLinkImage}
              src={`${process.env.PUBLIC_URL}/img/chevron-icon.svg`}
              alt="chevron icon"
              style={{ width: 10, height: 10 }}
            />
            back to search
          </button>
          {activeCouncil && activeCouncil.compare && (
            <button
              className={styles.compareButton}
              onClick={() => this.goToCompare()}
            >
              compare with another region
            </button>
          )}
        </div>
        {this.renderMaps()}
        {this.renderNoDataNotice()}
        {this.renderRegionTable()}
        {this.renderEntitiesLinks()}
      </div>
    );
  }
}

const mapDispatchToProps = {
  setActiveRegion,
  setComparedRegion,
  setActivePage,
  setActiveEntity,
  setComparedEntity,
};

const mapStateToProps = (state) => ({
  activeCouncil: selectors.getActiveCouncil(state),
  comparedCouncil: selectors.getComparedCouncil(state),
  comparing: selectors.getComparedCouncil(state) !== null,
  councils: selectors.getCouncils(state),
});

RegionPage.propTypes = {
  councils: PropTypes.arrayOf(PropTypes.object),
  setActiveRegion: PropTypes.func,
  setComparedRegion: PropTypes.func,
  activeCouncil: PropTypes.object.isRequired,
  comparedCouncil: PropTypes.object,
  setActivePage: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(RegionPage);



// WEBPACK FOOTER //
// ./src/pages/region-page/region-page.js